import type { ReactNode } from 'react';

interface CollapsibleSectionProps {
  title: ReactNode;
  /** Initial open/closed state - uncontrolled after that (native `<details>` toggling), so this is read once and ignored on later re-renders. */
  defaultOpen?: boolean;
  children: ReactNode;
}

/**
 * A `<Card>`-styled, collapsible panel built on native `<details>`/
 * `<summary>` - no extra state, keyboard/accessibility support for free.
 * Used where a detail page has several optional sections (tags, custom
 * fields, tasks, notes, activity, ...) and showing all of them expanded
 * at once makes the page too long for a quick look.
 */
export function CollapsibleSection({
  title,
  defaultOpen = false,
  children,
}: CollapsibleSectionProps) {
  return (
    <details className="ne-collapsible" open={defaultOpen}>
      <summary className="ne-collapsible__summary">
        <span className="ne-collapsible__chevron" aria-hidden="true">
          ▸
        </span>
        {title}
      </summary>
      <div className="ne-collapsible__body">{children}</div>
    </details>
  );
}
